<div mat-dialog-content>
  <p>Share screen address:</p>
  <div class="d-flex align-items-center justify-content-between">
    <div class="col-11 p-0">
      <mat-form-field appearance="fill">
        <input [readonly]="true" [ngModel]="screenLink" matInput>
      </mat-form-field>
    </div>
    <button mat-icon-button class="copy-button" aria-label="Copy icon" matTooltip="Copy the link to clipboard"
      (click)="closeModal()" [cdkCopyToClipboard]="screenLink">
        <mat-icon svgIcon="copy"></mat-icon>
    </button>
  </div>
  <div class="d-flex row mt-4">
    <div class="col-5">
      <h6>Share content</h6>
      <ng-select
        [(ngModel)]="selectedWindowPreview"
        [items]="windowsPreviewInfo$ | async"
        [searchable]="false"
        [clearable]="false"
        (change)="onShareContentChanged()"
        placeholder="Select a content"
        class="content-select">

        <ng-template ng-label-tmp let-item="item">
          {{ item.Title }}
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="d-flex align-items-center">
            @if (item.Handle?.value && item.Image) {
              <img class="image" [src]="item.Image">
            }
            @else if (item.Image) {
              <img class="image" [imageSrc]="item.Image">
            }
            <span class="title ml-2" [matTooltip]="item.Title">{{ item.Title }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>

    <div class="col-4">
      <h6>Image resolution</h6>
      <mat-select [(ngModel)]="screenResolution" (selectionChange)="onResolutionChanged($event.value)"
        [disableOptionCentering]="true" panelClass="mat-resolution-select">
          @for (resolution of screenResolutions | keyvalue: originalOrder; track $index) {
            <mat-option [value]="resolution.value">{{ resolution.key }}</mat-option>
          }
      </mat-select>
    </div>

    <div class="col-3">
      <h6>Refresh rate</h6>
      <mat-select [(ngModel)]="refreshRate" (selectionChange)="onRefreshRateChanged($event.value)"
        [disableOptionCentering]="true" panelClass="mat-resolution-select">
          @for (refreshRate of refreshRates | keyvalue: originalOrder; track $index) {
            <mat-option [value]="refreshRate.value">{{ refreshRate.key }}</mat-option>
          }
      </mat-select>
    </div>
  </div>

  <div class="toggle-group mt-4">
    <mat-slide-toggle
      (change)="onToggleLabel($event.checked)">
        Display the label of the screen's name
      </mat-slide-toggle>

    <mat-slide-toggle
      [(ngModel)]="isPublicLink"
      (change)="onSetPublicParameter($event.checked)">
        Public - accessible without logging in
      </mat-slide-toggle>
  </div>

  <div class="d-flex justify-content-end mt-4">
    <button mat-raised-button type="button" class="btn btn-blue" (click)="selectScreens()">Select Screens</button>
  </div>

</div>
